import { useState } from 'react';
import type { DiscountCodeBlock as DiscountCodeBlockDoc } from '../types';

/**
 * Slevový kód — JEN se zobrazuje (Fáze 7 kupóny nezakládá ani nemění).
 * Tlačítko zkopíruje kód do schránky; klik se počítá jako interakce.
 */
export function DiscountCodeBlock({
  block,
  onCopy,
}: {
  block: DiscountCodeBlockDoc;
  onCopy: () => void;
}) {
  const [copied, setCopied] = useState(false);

  async function copy(): Promise<void> {
    onCopy();
    try {
      await navigator.clipboard.writeText(block.code);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch {
      // Bez schránky (nezabezpečený kontext) zůstává kód aspoň viditelný.
    }
  }

  return (
    <div className="layer-code">
      {block.label !== '' && <p className="layer-code-label">{block.label}</p>}
      <div className="layer-code-row">
        <code className="layer-code-value">{block.code}</code>
        <button type="button" className="layer-code-copy" onClick={() => void copy()}>
          {copied ? '✓' : block.copyLabel}
        </button>
      </div>
    </div>
  );
}
